import { render, staticRenderFns } from "./ThanksItemPc.vue?vue&type=template&id=503cb28e&scoped=true&"
import script from "./ThanksItemPc.vue?vue&type=script&lang=ts&"
export * from "./ThanksItemPc.vue?vue&type=script&lang=ts&"
import style0 from "./ThanksItemPc.vue?vue&type=style&index=0&id=503cb28e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503cb28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VImg,VSpacer})
